module.exports = __webpack_public_path__ + "workspace/static/img/psaOne.7f19f86.png";